import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import SchoolMarker from './marker';

const SchoolMarkers = ({ schools, onClick, selectedId }) => (
  <div>
    {_.map(schools, school => (
      <SchoolMarker
        key={school.id}
        school={school}
        onClick={onClick}
        selected={selectedId === school.id}
      />))}
  </div>
);

SchoolMarkers.defaultProps = {
  selectedId: null,
  schools: [],
};

SchoolMarkers.propTypes = {
  schools: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
  })),
  onClick: PropTypes.func.isRequired,
  selectedId: PropTypes.number,
};

export default SchoolMarkers;
